import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBackward: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBackward"><Path d="M15.5 9.5L13 12M13 12L10.5 14.5M13 12L10.5 9.5M13 12L15.5 14.5M6 4.5H21.5V19.5H6L1.5 12L6 4.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBackward;
